var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.has.js
 **/